(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentServiceItemAccessDeleteController', AgentServiceItemAccessDeleteController);

    AgentServiceItemAccessDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentServiceItemAccess'];

    function AgentServiceItemAccessDeleteController($uibModalInstance, entity, AgentServiceItemAccess) {
        var vm = this;

        vm.agentServiceItemAccess = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentServiceItemAccess.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
